import React, { useContext, useState, useEffect } from 'react';
import Navbar from '../../components/navbar';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import './style.scss';
import { ArrowBack, Mail } from '@material-ui/icons';
import CustomSnackbar from '../../components/snack';
import { useForm } from 'react-hook-form';
import { getAvatar } from '../../components/avatar';
import RefreshIcon from '@material-ui/icons/Refresh';
import { Context } from '../../store';
import axios from 'axios';
import CustomLoader from '../../components/loader/customLoader';
import { BACKURL } from '../../components/network';

const Profile = (props) => {
  const {
    state: { username, userImg, email },
  } = useContext(Context);
  const [file, setFile] = useState(userImg);
  const { register, handleSubmit } = useForm();
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState('');
  const [loading, setLoading] = useState(false);
  const { dispatch } = useContext(Context);
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  useEffect(() => {
    // console.log(props);
    const copyToken = JSON.parse(localStorage.getItem('copy-user'));
    if (!copyToken || props.match.params.id !== copyToken.token) {
      window.location.href = '/main';
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const sendData = async (details) => {
    setLoading(true);
    const data = await axios.put(`${BACKURL}/update-profile`, details);
    setLoading(false);

    if (!data.data.done) {
      setMsg(data.data.msg.note);
      setOpen(true);
      return;
    }
    setMsg(data.data.msg);
    setOpen(true);
    dispatch({
      type: 'SET_USER_DATA',
      payload: details,
    });
  };
  const Submit = async (data) => {
    if (data.username === username && userImg === file) {
      // console.log('no change');
      return;
    }
    // console.log({
    //   u1: data.username,
    //   u2: username,
    //   i1: userImg,
    //   i2: file,
    // });
    sendData({ ...data, email: email, userImg: file });
  };
  return (
    <>
      {loading ? <CustomLoader /> : null}
      <div className='profile-wrapper'>
        <Navbar props={props} />
        <div
          className='redirect-btn'
          style={{
            cursor: 'pointer',
          }}
          onClick={() => props.history.goBack()}>
          <ArrowBack />
        </div>
        <div className='usericon-wrapper'>
          <img className='user-img' src={file} alt='user-icon' />
        </div>
        <div
          className='del-icon'
          onClick={() => {
            setFile(getAvatar);
          }}>
          <RefreshIcon />
        </div>
        <form
          onSubmit={handleSubmit(Submit)}
          className='login-btn'
          style={{
            marginTop: '0px',
          }}>
          <div className='input-btn'>
            <Mail />
            <input
              type='email'
              placeholder='Email'
              ref={register}
              name='email'
              value={email}
              disabled
            />
          </div>
          <div className='input-btn'>
            <PersonOutlineIcon />
            <input
              placeholder='Username'
              ref={register}
              name='username'
              maxLength='10'
              defaultValue={username}
            />
          </div>
          <button className='btn-reg'>Update</button>
        </form>
        <CustomSnackbar open={open} handleClose={handleClose} msg={msg} />
      </div>
    </>
  );
};

export default Profile;
